<template>
  <div class="w-100">
    <UpdateAGroupClass></UpdateAGroupClass>
    <GroupClassMasterList
      :selectedGroupClassId="$route.params.id"
    ></GroupClassMasterList>
  </div>
</template>

<script>
export default {
  components: {
    UpdateAGroupClass,
    GroupClassMasterList,
  },
};
import UpdateAGroupClass from "@/views/components/GroupClass/UpdateAGroupClass.vue";
import GroupClassMasterList from "@/views/components/GroupClass/GroupClassMasterList.vue";
</script>
